import { IFeature } from 'mod/featureV2/interface';

export const swiperReviews: IFeature = {
    type: 'swiperReviews',
    title: 'swiperReviews',
    description: 'The number of reviews on the PC side should preferably be a multiple of 4, and there is no limit on the M side.',
    config: {
        speed: 50,
        gutter: 20,
    },
    list: new Array(8).fill(void 0).map((_, index) => ({
        variantId: '58820960379609901',
        content: index + ' The top of the vgrow box has a very slick glass top that weighs 10+ pounds. Poles and manual sensor have some wiggle in them but the poles are well connected. Skin is a very thick and soft faux leather with a heavy duty zipper. Light is intense the pictures of the lights are 25%, 60% 100%. Fans are comfortably quiet but anything over 6 gets loud. Included close up of upper corner to show how power cable of third party cam can fit without letting light out and you can tuck it in the back groove, well done. App is extremely interactive and you can control every aspect of the tent. Only thing is the outside temp sensors need to be calibrated and a setting to dim the logo would be nice 🙏 but super happy with the purchase and I’m so psyched to start training. Plus zippers fit small locks which is awesome. Drip irrigation kit works very well the coco coir is perfectly saturated at least on top. ',
        userName: 'aafdajsfdls',
        rate: 4,
        images: [{
            cover: 'asset/width-1110/picture/e8a31eaa2c677faee688128e00f10e49.jpg',
            picUrl: 'asset/width-1110/picture/e8a31eaa2c677faee688128e00f10e49.jpg',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }, {
            picUrl: 'asset/width-1920/picture/98dd860b855df2c3c89fa371c1c87fdb.jpg',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }, {
            picUrl: 'https://cdn-2.jjshouse.com/upimg/jjshouse/o600/a6/7c/03f05003c6b225635a94ecff40d9a67c.jpg',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }, {
            picUrl: 'file-asset/file/c9ad82eca9ee1df5fd954ca310453e62.webp',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }, {
            picUrl: 'asset/width-600/picture/d3adb873791605fb47b2c7eec43e0186.jpg',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }, {
            picUrl: 'asset/width-1466/picture/a73492fe80e76f5d7afabff3e4a9c674.jpg',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }, {
            picUrl: 'asset/width-1920/picture/98dd860b855df2c3c89fa371c1c87fdb.jpg',
            altText: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        }]
    }))
};

export const swiperReviews2: IFeature = {
    ...swiperReviews,
    vars: {
        '--feature-card-bg': '#fbfbfb',
        '--feature-card-color': '#141414',
    }
};

